module.exports = __webpack_public_path__ + "img/892002960.c95c607c.png";